import billingTemplate from './billing.html';

export default angular
  .module('main.organizations.edit.tabs.billing', [])

  .directive('editOrganizationBillingTab', () => {
    return {
      restrict: 'E',
      template: billingTemplate,
      scope: {},
      controller: ($scope,
                   $state,
                   $q,
                   $filter,
                   $window,
                   utils,
                   ToastsService,
                   EditOrganizationDataProvider,
                   I18nService) => {
        const $t = $filter('translate');
        const locale = I18nService.getLocale()?.code || 'en';
        const SELECTED_BILLING_PLAN_LOCAL_STORAGE_KEY = 'Selected-Billing-Plan';

        $scope.dataProvider = EditOrganizationDataProvider.instance;

        angular.extend($scope, {
          downloadBill: downloadBill,
          formatPrice: formatPrice,
          setupBillingAccess: setupBillingAccess,
          gotoBillingSetup: gotoBillingSetup,
          gotoBillingPlans: gotoBillingPlans,
          gotoPlanDetails: gotoPlanDetails,
        });

        // Datepicker options
        $scope.billsDatePickerOptions = {
          language: locale,
          position: 'bottom left',
          view: 'months',
          minView: 'months',
          autoClose: true,
          maxDate: new Date(),
          clearButton: true,
          dateFormat: 'mm/yyyy',
          range: true,
        };

        init();

        function init() {
          $scope.loading = true;
          $scope.loadingPlan = true;

          $q.all([
            $scope.dataProvider.organizationResource.init(),
            $scope.dataProvider.organizationIdResource.init(),
            $scope.dataProvider.organizationBillingPlansResource.init(),
          ])
            .then(() => {
              getCurrentBillingPlan();
              getOrganizationBills();
              initWatchers();
              $scope.loading = false;
            }, () => {
              $scope.loading = false;
              $scope.loadingPlan = false;
            });
        }

        function initWatchers() {
          $scope.$watch('billingDate', (newValue, oldValue) => {
            if (!utils.compareArrays(oldValue, newValue)) {
              getOrganizationBills();
            }
          });
        }

        function getCurrentBillingPlan() {
          let now = new Date().getTime();
          let organizationBillingPlans = angular.copy($scope.dataProvider.organizationBillingPlansResource.value);
          $scope.billingPlan = organizationBillingPlans.find(plan => plan.startDateMs <= now && plan.endDateMs > now);
          $scope.loadingPlan = false;
        }

        function getOrganizationBills() {
          let startDate;
          let endDate;
          if (!$scope.billingDate || $scope.billingDate.length === 0) {
            let nowMoment = moment();
            startDate = nowMoment
              .subtract(12, 'months')
              .startOf('month')
              .valueOf();
          } else {
            endDate = $scope.billingDate[$scope.billingDate.length - 1];
            startDate = moment.tz(moment($scope.billingDate[0])
              .format('L'), 'L', 'UTC')
              .startOf('day')
              .valueOf();
            endDate = moment.tz(moment(endDate)
              .format('L'), 'L', 'UTC')
              .endOf('day')
              .valueOf();
          }

          $scope.dataProvider.searchOrganizationBills(startDate, endDate)
            .then(data => {
              $scope.bills = data || [];
            });
        }

        function downloadBill(bill, isCsv, $event) {
          if (!bill) {
            return;
          }

          const format = isCsv ? 'csv' : 'pdf';

          $scope.dataProvider.getOrganizationBill(bill.billId, format)
            .then((blob) => {
              let filename = `receipt-${$scope.dataProvider.organizationIdResource.value}-${bill.startDate}.${format}`;
              filename = decodeURI(filename);
              var url = ($window.URL || $window.webkitURL).createObjectURL(new Blob([blob]));

              return utils.downloadFile(url, filename)
                .then(() => {
                  // Success
                }, (err) => {
                  console.warn(err);
                  ToastsService.error(null, $t('reports.view.history.downloadError'));
                });
            });
        }

        /**
         * Format the cost value
         * @param {number} value
         * @returns {number}
         */
        function formatPrice(value) {
          if (!value) return 0;
          return value / 100;
        }

        function setupBillingAccess() {
          return utils.canISetupBilling;
        }

        function gotoBillingSetup() {
          $state.go('main.billing.list', {
            from: 'organization',
            organizationId: $scope.dataProvider.organizationIdResource.value,
          });
        }

        function gotoBillingPlans() {
          $scope.dataProvider.activeTab = 'billingPlans';
        }

        function gotoPlanDetails() {
          // TODO: Remove this when the billing plans are ready
          return;

          utils.setStorageItem(SELECTED_BILLING_PLAN_LOCAL_STORAGE_KEY, $scope.billingPlan);
          $state.go('main.billing.plan', {
            from: 'organization',
            organizationId: $scope.dataProvider.organizationIdResource.value,
          });
        }

      }
    };
  })
  .name;
